import React from 'react';
import classnames from 'classnames';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Flex from '@wix/da-ds/pkg/Flex';
import s from './StatisticsBarItem.scss';
const StatisticsBarItem = ({ icon: IconComponent , label , className  })=>/*#__PURE__*/ React.createElement(Flex, {
        inline: true,
        className: classnames(s['root'], className),
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(IconComponent, {
        className: s['icon'],
        size: IconSize.SMALLER,
        disableDefaultColors: true
    }), /*#__PURE__*/ React.createElement("span", null, label));
StatisticsBarItem.displayName = 'StatisticsBarItem';
export default StatisticsBarItem;
